import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import OnboardingPage from './pages/OnboardingPage';
import { ONBOARDING_SCOPES } from './onboardingScopes';

export const OnboardingRoutes = () => (
  <Route path="onboarding">
    <Route
      index
      element={
        <ProtectedRoute requiredScopes={ONBOARDING_SCOPES} requireAll>
          <OnboardingPage />
        </ProtectedRoute>
      }
    />
  </Route>
);
